// extracted by mini-css-extract-plugin
module.exports = {"CustomerVoice":"CustomerVoice___2RnpU","lightMode":"lightMode___2ZyMP"};